import styled from 'styled-components';

export const StyledAcceptedFileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
`;
